import React from 'react';
import Storage, { STORE_KEYS } from '../../../services/Storage';
import { isValidNumber } from '../../../utils';
import Component from '../../Component';
import FewStepsAway from '../components/FewStepsAway';
import HotelOwners from '../components/HotelOwners';
import Testimonial from '../components/Testimonial';

export default class CyclicBanner1 extends Component {

    banners = [
        FewStepsAway, HotelOwners, Testimonial
    ];

    state = {
        index: null,
    }

    store_key = STORE_KEYS.CYCLIC_BANNER1_INDEX;

    getOverrideProps = () => ({});

    componentDidMount = () => {
        let currentIndex = Storage.getItem(this.store_key);
        currentIndex = isValidNumber(currentIndex) ? currentIndex : 0;
        this.setState({ index: currentIndex });
        Storage.setItem(this.store_key, currentIndex + 1 > 100 ? 0 : currentIndex + 1);
    }

    render = () => {
        const { index } = this.state;
        const Banner = (!isValidNumber(index) || index < 0) ? this.banners[0]
            : (this.banners[index % this.banners.length] || this.banners[0]);
        return <Banner {...this.props} {...this.getOverrideProps()} />;
    }

}